setTimeout(() =>{
    let quickViewBtn =document.querySelectorAll('[id^="quick-add-"]');
    console.log({quickViewBtn})
    if (quickViewBtn.length) {
        for (let i = 0; i < quickViewBtn.length; i++) {
            quickViewBtn[i].onclick = function () {
                setTimeout(function () {
                const variantInput = document.querySelector(".quick-add-modal input[name='id']");
                    BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), '.quick-add-modal .price', false, true, Number(variantInput.value));
                    
                    const changeVariant = mutations => {
                                console.log(2333)
                                const valueVariant = variantInput.value
                                console.log("valueVariant ", valueVariant)
                                setTimeout(() => {
                                    BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), "[bss-b2b-product-active]", false, true, valueVariant);
                                }, 500);
                            
                    };
                    const observer = new MutationObserver(changeVariant);
                    observer.observe(variantInput, {
                        attributes: true,
                    });
                    
                }, 1500);
            }
        }
    }
}, 3000)